import CsrfToken from '@rmp-shared/helpers/http/csrf-token';

const LOGOUT_URL = '/accounts/sign_out.json';

export class Window {
  /* istanbul ignore next */
  static goTo(targetUrl, _window = window) {
    _window.location.href = targetUrl;
  }
}

export default class CrispManager {
  constructor() {
    this._isProcessing = false;

    const triggerEls = document.body.querySelectorAll('[data-sign-out]');
    triggerEls.forEach(t => {
      t.addEventListener('click', this.clickPerformed.bind(this));
    });
  }

  async clickPerformed(ev) {
    ev.preventDefault();

    if (this._isProcessing) return;

    this._isProcessing = true;

    const data = {
      authenticity_token: CsrfToken.get(),
    };

    const options = {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    };

    try {
      const res = await fetch(LOGOUT_URL, options);
      const data = res.json();
      const targetUrl = data.root_url || window.location.origin;
      Window.goTo(targetUrl);
    } catch (error) {
      this._isProcessing = false;

      window.Reedsy.logger.error(error);
    }
  }
}
